import { Routes } from '@angular/router';
// Components
import { BaseComponent } from './views/theme/base/base.component';
import { ErrorPageComponent } from './views/theme/content/error-page/error-page.component';
// Auth
// import {AuthGuard} from './core/auth';
import { MachineListComponent } from './views/pages/machine-list/machine-list.component';
import { RegisterMachineComponent } from './views/pages/register-machine/register-machine.component';
import { AuthGuardService } from './core/_guard/auth-guard.service';
import { RoleGuardService } from './core/_guard/role-guard.service';
import { FeatureFlagGuardService } from './core/_guard/feature-flag-guard.service';
import { PortalViewGuardService } from './core/_guard/portal-view-guard.service';
import { BulkActionsComponent } from './views/pages/bulk-actions/bulk-actions.component';
import { SubsConfirmationComponent } from './views/pages/subs-confirmation/subs-confirmation.component';
import { AnalyticsComponent } from './views/pages/analytics/analytics.component';
import { MachineResolver } from './views/pages/machine/machine.resolver';
var ɵ0 = function () { return import("./views/pages/auth/auth.module.ngfactory").then(function (m) { return m.AuthModuleNgFactory; }); }, ɵ1 = function () { return import("./views/pages/new-dashboard/new-dashboard.module.ngfactory").then(function (m) { return m.NewDashboardModuleNgFactory; }); }, ɵ2 = function () { return import("./views/pages/user-settings/user-settings.module.ngfactory").then(function (m) { return m.UserSettingsModuleNgFactory; }); }, ɵ3 = { roles: ['sadmin'], featureFlag: 'card_reader_list' }, ɵ4 = function () { return import("./views/pages/card-readers/card-readers.module.ngfactory").then(function (m) { return m.CardReadersModuleNgFactory; }); }, ɵ5 = { roles: ['sadmin'] }, ɵ6 = function () { return import("./views/pages/retail-analytics/retail-analytics.module.ngfactory").then(function (m) { return m.RetailAnalyticsModuleNgFactory; }); }, ɵ7 = { roles: ['sadmin'], featureFlag: 'cold_brew' }, ɵ8 = function () { return import("./views/pages/cold-brew/cold-brew.module.ngfactory").then(function (m) { return m.ColdBrewModuleNgFactory; }); }, ɵ9 = function () { return import("./views/pages/banners/banners.module.ngfactory").then(function (m) { return m.BannersModuleNgFactory; }); }, ɵ10 = function () { return import("./views/pages/machine/machine.module.ngfactory").then(function (m) { return m.MachineModuleNgFactory; }); }, ɵ11 = function () { return import("./views/pages/clients/clients.module.ngfactory").then(function (m) { return m.ClientsModuleNgFactory; }); }, ɵ12 = function () { return import("./views/pages/users/users.module.ngfactory").then(function (m) { return m.UsersModuleNgFactory; }); }, ɵ13 = { roles: ['sadmin'] }, ɵ14 = function () { return import("./views/pages/packages/packages.module.ngfactory").then(function (m) { return m.PackagesModuleNgFactory; }); }, ɵ15 = { roles: ['sadmin'], featureFlag: 'camera_audit' }, ɵ16 = function () { return import("./views/pages/camera-audit-live/camera-audit.module.ngfactory").then(function (m) { return m.CameraAuditModuleNgFactory; }); }, ɵ17 = function () { return import("./views/pages/inventory/inventory.module.ngfactory").then(function (m) { return m.InventoryModuleNgFactory; }); }, ɵ18 = function () { return import("./views/pages/new-dashboard/new-dashboard.module.ngfactory").then(function (m) { return m.NewDashboardModuleNgFactory; }); }, ɵ19 = { roles: ['sadmin'] }, ɵ20 = { roles: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'], featureFlag: 'orders' }, ɵ21 = function () { return import("./views/pages/orders/orders.module.ngfactory").then(function (m) { return m.OrdersModuleNgFactory; }); }, ɵ22 = { roles: ['sadmin', 'campusadmin'], featureFlag: 'vouchers' }, ɵ23 = function () { return import("./views/pages/voucher/voucher.module.ngfactory").then(function (m) { return m.VoucherModuleNgFactory; }); }, ɵ24 = { roles: ['sadmin'], featureFlag: 'vouchers' }, ɵ25 = function () { return import("./views/pages/voucher/voucher-ops.module.ngfactory").then(function (m) { return m.VoucherOpsModuleNgFactory; }); }, ɵ26 = { roles: ['sadmin'], featureFlag: 'flex_mock' }, ɵ27 = function () { return import("./views/pages/subsidies/subsidies.module.ngfactory").then(function (m) { return m.SubsidiesModuleNgFactory; }); }, ɵ28 = {
    type: 'error-v6',
    code: 403,
    title: '403... Access forbidden',
    desc: 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator',
};
var routes = [
    { path: 'confirm', component: SubsConfirmationComponent },
    { path: '', loadChildren: ɵ0 },
    {
        path: '',
        component: BaseComponent,
        canActivateChild: [PortalViewGuardService],
        children: [
            {
                path: 'dashboard',
                canActivateChild: [AuthGuardService],
                loadChildren: ɵ1,
            },
            {
                path: 'user-settings',
                canActivateChild: [AuthGuardService],
                loadChildren: ɵ2,
            },
            {
                path: 'card-readers',
                canActivate: [AuthGuardService, RoleGuardService, FeatureFlagGuardService],
                data: ɵ3,
                loadChildren: ɵ4,
            },
            {
                path: 'retail-analytics',
                canActivate: [AuthGuardService, RoleGuardService],
                data: ɵ5,
                loadChildren: ɵ6,
            },
            {
                path: 'cold-brew',
                canActivate: [AuthGuardService, RoleGuardService, FeatureFlagGuardService],
                data: ɵ7,
                loadChildren: ɵ8,
            },
            {
                path: 'machine-list',
                canActivateChild: [AuthGuardService],
                component: MachineListComponent,
            },
            {
                path: 'banners',
                canActivateChild: [AuthGuardService],
                loadChildren: ɵ9,
            },
            {
                path: 'machine/:machineId',
                canActivateChild: [AuthGuardService],
                resolve: { machine: MachineResolver },
                loadChildren: ɵ10,
            },
            {
                path: 'clients',
                canActivateChild: [AuthGuardService],
                loadChildren: ɵ11,
            },
            {
                path: 'bulk-update',
                canActivateChild: [AuthGuardService],
                component: BulkActionsComponent,
            },
            {
                path: 'users',
                canActivateChild: [AuthGuardService],
                loadChildren: ɵ12,
            },
            {
                path: 'package',
                canActivateChild: [AuthGuardService, RoleGuardService],
                data: ɵ13,
                loadChildren: ɵ14
            },
            {
                path: 'audits',
                canActivateChild: [AuthGuardService, RoleGuardService, FeatureFlagGuardService],
                data: ɵ15,
                loadChildren: ɵ16
            },
            {
                path: 'analytics',
                canActivateChild: [AuthGuardService],
                component: AnalyticsComponent,
            },
            {
                path: 'inventory',
                canActivateChild: [AuthGuardService],
                loadChildren: ɵ17,
            },
            {
                path: 'new-dashboard',
                canActivateChild: [AuthGuardService],
                loadChildren: ɵ18,
            },
            {
                path: 'register-machine',
                canActivate: [AuthGuardService, RoleGuardService],
                data: ɵ19,
                component: RegisterMachineComponent,
            },
            {
                path: 'orders',
                canActivateChild: [AuthGuardService, RoleGuardService, FeatureFlagGuardService],
                data: ɵ20,
                loadChildren: ɵ21,
            },
            {
                path: 'voucher',
                canActivateChild: [AuthGuardService, RoleGuardService, FeatureFlagGuardService],
                data: ɵ22,
                loadChildren: ɵ23,
            },
            {
                path: 'voucher-ops',
                canActivateChild: [AuthGuardService, RoleGuardService, FeatureFlagGuardService],
                data: ɵ24,
                loadChildren: ɵ25,
            },
            {
                path: 'flex',
                canActivateChild: [AuthGuardService, RoleGuardService, FeatureFlagGuardService],
                data: ɵ26,
                loadChildren: ɵ27,
            },
            {
                path: 'error/403',
                component: ErrorPageComponent,
                data: ɵ28,
            },
            { path: 'error/:type', component: ErrorPageComponent },
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
        ],
    },
    { path: '**', redirectTo: 'error/403', pathMatch: 'full' },
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28 };
